import { FileText, ShieldCheck, Search, ScrollText, Gauge, Building2 } from "lucide-react";

// Le 6 macroaree mostrate in homepage
export const MACROAREE = [
  {
    slug: "servizi-catastali",
    title: "Catasto e DOCFA",
    icon: FileText,
    text: "Variazioni, aggiornamenti, planimetrie, visure e pratiche catastali.",
  },
  {
    slug: "conformita-urbanistica-catastale",
    title: "Conformità urbanistica e catastale",
    icon: ShieldCheck,
    text: "Verifica e regolarizzazione della coerenza tra stato di fatto, titoli edilizi e catasto.",
  },
  {
    slug: "visure-verifiche-immobiliari",
    title: "Visure e verifiche immobiliari",
    icon: Search,
    text: "Visure catastali e ipotecarie, verifiche e consulenza documentale sull’immobile.",
  },
  {
    slug: "successioni",
    title: "Successioni e pratiche documentali",
    icon: ScrollText,
    text: "Dichiarazione di successione, volture e gestione della documentazione tecnica.",
  },
  {
    slug: "ape-perizie-valutazioni",
    title: "APE, perizie e valutazioni",
    icon: Gauge,
    text: "Attestati di prestazione energetica, perizie tecniche e valutazioni immobiliari.",
  },
  {
    slug: "urbanistica-edilizia",
    title: "Urbanistica, edilizia e progettazione",
    icon: Building2,
    text: "Pratiche edilizie, progettazione, direzione lavori, computi e preventivi.",
  },
];

// Catalogo completo organizzato per macroaree (pagina /servizi)
export const AREAS = [
  {
    id: "catasto",
    label: "Catasto e servizi catastali",
    path: "/servizi-catastali",
    services: [
      "Catasto",
      "SISTER",
      "DOCFA",
      "Variazioni catastali",
      "Aggiornamenti catastali",
      "Planimetrie",
      "Visure catastali",
      "Pratiche catastali",
      "Conformità catastale",
    ],
    also: [{ label: "Conformità urbanistica e catastale", path: "/conformita-urbanistica-catastale" }],
  },
  {
    id: "conservatoria",
    label: "Conservatoria e verifiche immobiliari",
    path: "/visure-verifiche-immobiliari",
    services: [
      "Conservatoria",
      "Verifiche ipotecarie",
      "Visure",
      "Verifiche immobiliari",
      "Consulenza documentale sull’immobile",
    ],
  },
  {
    id: "urbanistica",
    label: "Urbanistica ed edilizia",
    path: "/urbanistica-edilizia",
    services: [
      "Conformità urbanistica",
      "Pratiche edilizie",
      "Urbanistica",
      "Progettazione",
      "Ristrutturazioni",
      "Direzione lavori",
      "Computi",
      "Preventivi",
      "Documentazione tecnica",
    ],
    also: [{ label: "Conformità urbanistica e catastale", path: "/conformita-urbanistica-catastale" }],
  },
  {
    id: "immobiliari",
    label: "Prestazioni immobiliari",
    path: "/ape-perizie-valutazioni",
    services: [
      "APE — Attestato di Prestazione Energetica",
      "Perizie tecniche",
      "Valutazioni immobiliari",
      "Perizie su danni",
      "Perizie su difetti",
      "Verifica dello stato dell’immobile",
      "Consulenza tecnica immobiliare",
      "Tabelle millesimali",
    ],
  },
  {
    id: "documentazione",
    label: "Pratiche e documentazione",
    path: "/consulenza-tecnica-documentale",
    services: [
      "Successioni",
      "Contratti di locazione",
      "Comodati",
      "Preliminari",
      "Altre scritture private compatibili con l’attività professionale",
      "Consulenza tecnica e documentale",
    ],
    also: [{ label: "Successioni e pratiche documentali", path: "/successioni" }],
  },
  {
    id: "sicurezza",
    label: "Sicurezza e prevenzione",
    path: "/sicurezza-prevenzione",
    services: ["Sicurezza cantieri", "CSP", "CSE", "RSPP", "Prevenzione incendi"],
  },
  {
    id: "digitali",
    label: "Servizi digitali",
    path: "/siti-web-personalizzati",
    services: ["Creazione di siti web personalizzati"],
    note: "Servizio digitale autonomo, separato dall’attività tecnico-professionale dello studio.",
  },
];

// Opzioni del menu a tendina del form
export const SERVICE_OPTIONS = [
  "Catasto e DOCFA",
  "Conformità urbanistica e catastale",
  "Visure e verifiche immobiliari",
  "Successioni e pratiche documentali",
  "APE, perizie e valutazioni immobiliari",
  "Urbanistica, edilizia e progettazione",
  "Sicurezza e prevenzione",
  "Consulenza tecnica e documentale",
  "Sito web personalizzato",
  "Altro / Non so",
];

// Contenuti delle pagine servizio SEO
export const DETAIL = {
  "servizi-catastali": {
    h1: "Catasto e DOCFA",
    description:
      "Pratiche catastali in tutta Italia: DOCFA, variazioni e aggiornamenti catastali, planimetrie, visure e conformità catastale. Valutazione gratuita, risposta entro 24 ore.",
    intro:
      "Il catasto è la base documentale di ogni immobile: compravendite, successioni, pratiche edilizie e agevolazioni fiscali partono dai suoi dati. Gestiamo le principali pratiche catastali con l’Agenzia delle Entrate, con un unico interlocutore dall’apertura alla conclusione.",
    quando: [
      "Hai effettuato un intervento edilizio e devi aggiornare la planimetria catastale.",
      "Devi variare gli intestatari o le consistenze di un immobile.",
      "Ti servono visure catastali o copie di planimetrie per una pratica o un contratto.",
      "Hai riscontrato disallineamenti tra stato di fatto e dati catastali da sistemare prima di una vendita o di una successione.",
    ],
    cosa: [
      "Pratiche DOCFA e aggiornamento delle planimetrie",
      "Variazioni e aggiornamenti catastali",
      "Visure catastali e copie degli atti",
      "Rettifiche e sistemazioni planimetriche",
      "Verifica della conformità catastale dell’immobile",
      "Gestione delle comunicazioni con il catasto via SISTER",
    ],
    aDistanza:
      "Molte pratiche catastali possono essere gestite a distanza tramite i servizi telematici dell’Agenzia delle Entrate. La documentazione e le eventuali deleghe o firme necessarie vengono definite in base alla pratica.",
    formService: "Catasto e DOCFA",
  },
  "conformita-urbanistica-catastale": {
    h1: "Conformità urbanistica e catastale",
    description:
      "Verifica della conformità urbanistica e catastale degli immobili: analisi dei titoli, rilievi e regolarizzazione prima di vendere, acquistare o chiedere un mutuo.",
    intro:
      "La conformità urbanistica e catastale accerta che lo stato dell’immobile corrisponda ai titoli edilizi e ai dati catastali. È uno dei controlli più delicati in compravendite, mutui, successioni e sanatorie: anticiparlo evita tempi morti e sorprese.",
    quando: [
      "Prima di vendere o acquistare un immobile, soprattutto se nel tempo sono stati fatti lavori.",
      "La banca richiede la conformità per l’erogazione di un mutuo.",
      "Serve sanare un difetto edilizio o catastale emerso in una pratica.",
      "Si apre una successione con immobili non allineati.",
    ],
    cosa: [
      "Analisi dei titoli edilizi e della storia dell’immobile",
      "Verifica di coerenza tra progetto, stato di fatto e catasto",
      "Rilievo e aggiornamento della documentazione catastale",
      "Presentazione delle pratiche di regolarizzazione, dove possibile",
      "Relazione di conformità per banche, notai e privati",
    ],
    aDistanza:
      "L’analisi documentale e la verifica si svolgono a distanza. Se serve un rilievo sul posto, valutiamo insieme il sopralluogo.",
    formService: "Conformità urbanistica e catastale",
  },
  "visure-verifiche-immobiliari": {
    h1: "Visure e verifiche immobiliari",
    description:
      "Visure catastali e ipotecarie, verifiche su titolarità, ipoteche e formalità: conoscere la situazione reale dell’immobile prima di decidere. Anche a distanza.",
    intro:
      "Prima di un acquisto, di un contratto o di una trattativa è fondamentale conoscere la situazione reale dell’immobile: intestazioni, ipoteche, formalità e dati catastali. Richiediamo e analizziamo i documenti per darti un quadro chiaro.",
    quando: [
      "Stai per comprare un immobile e vuoi verificarne la posizione.",
      "Devi controllare l’esistenza di ipoteche o formalità su un bene.",
      "Serve documentazione aggiornata per un contratto di locazione o un preliminare.",
      "Vuoi capire la composizione catastale di un fabbricato o di una porzione.",
    ],
    cosa: [
      "Visure catastali",
      "Visure ipotecarie e di conservatoria",
      "Verifiche sulla titolarità degli immobili",
      "Verifica della coerenza dei dati catastali",
      "Consulenza documentale sull’immobile",
    ],
    aDistanza:
      "Le visure e le verifiche si richiedono e si consegnano interamente a distanza, con consegna digitale dei documenti.",
    formService: "Visure e verifiche immobiliari",
  },
  successioni: {
    h1: "Successioni e pratiche documentali",
    description:
      "Pratica di successione e adempimenti collegati: dichiarazione di successione, volture catastali e documentazione tecnica degli immobili, anche a distanza.",
    intro:
      "Dopo la scomparsa di una persona cara gli adempimenti seguono tempi precisi. Ci occupiamo della pratica di successione e degli aspetti tecnici collegati agli immobili, seguendo gli eredi passo dopo passo.",
    quando: [
      "Occorre presentare la dichiarazione di successione.",
      "Gli immobili ereditati devono essere intestati agli eredi.",
      "Si vuole vendere o dividere un immobile ereditato.",
      "Serve verificare la regolarità catastale ed edilizia degli immobili in successione.",
    ],
    cosa: [
      "Presentazione della dichiarazione di successione",
      "Volture catastali a favore degli eredi",
      "Verifica della regolarità catastale ed edilizia degli immobili eredite",
      "Gestione della documentazione tecnica della pratica",
      "Collaborazione con notai e altri professionisti coinvolti",
    ],
    aDistanza:
      "Dopo un primo contatto, la pratica può essere seguita a distanza con documenti digitali e firme elettroniche.",
    formService: "Successioni e pratiche documentali",
  },
  "ape-perizie-valutazioni": {
    h1: "APE, perizie e valutazioni immobiliari",
    description:
      "Attestato di prestazione energetica, perizie tecniche e valutazioni immobiliari: una lettura professionale e imparziale del valore e delle condizioni dell’immobile.",
    intro:
      "Dalla certificazione energetica alle stime del valore, offriamo una lettura tecnica e imparziale dell’immobile: utile per vendere, affittare, dividere, assicurare o affrontare una contestazione.",
    quando: [
      "Devi vendere o affittare un immobile e serve l’APE.",
      "Vuoi una stima del valore di mercato dell’immobile.",
      "Serve accertare un danno o un difetto costruttivo.",
      "Ti serve una verifica dello stato dell’immobile o una consulenza tecnica.",
    ],
    cosa: [
      "APE — Attestato di Prestazione Energetica",
      "Perizie tecniche e stime del valore",
      "Valutazioni immobiliari",
      "Perizie su danni e su difetti",
      "Verifica dello stato dell’immobile",
      "Tabelle millesimali e consulenza tecnica immobiliare",
    ],
    aDistanza:
      "Le perizie documentali possono avviarsi a distanza; per APE, rilievi e sopralluoghi organizziamo l’intervento sul posto, valutandone insieme modalità e tempi.",
    formService: "APE, perizie e valutazioni immobiliari",
  },
  "urbanistica-edilizia": {
    h1: "Urbanistica, edilizia e progettazione",
    description:
      "Pratiche edilizie, progettazione, direzione lavori, computi e preventivi: un interlocutore unico verso il Comune, dall’idea alla fine dei lavori.",
    intro:
      "Dalla ristrutturazione alla nuova costruzione, seguiamo la pratica edilizia dall’idea alla fine dei lavori: progettazione, iter con il Comune, direzione lavori e documentazione tecnica.",
    quando: [
      "Vuoi ristrutturare, ampliare o cambiare destinazione d’uso.",
      "Devi presentare CILA, SCIA o permesso di costruire.",
      "Ti serve un computo metrico o un preventivo realistico prima di affidare i lavori.",
      "Il cantiere richiede direzione lavori e coordinamento.",
    ],
    cosa: [
      "Pratiche edilizie: CILA, SCIA, permesso di costruire",
      "Progettazione e documentazione tecnica",
      "Conformità urbanistica dell’immobile",
      "Direzione lavori e coordinamento tecnico",
      "Computi metrici estimativi e preventivi",
      "Assistenza fino alla conclusione dei lavori",
    ],
    aDistanza:
      "Le pratiche e la progettazione si seguono a distanza; per cantiere e sopralluoghi operiamo sul territorio, concordando di volta in volta la presenza.",
    formService: "Urbanistica, edilizia e progettazione",
  },
  "sicurezza-prevenzione": {
    h1: "Sicurezza e prevenzione",
    remoteLabel: "Gestione delle attività",
    description:
      "Documentazione di sicurezza nei cantieri: CSP, CSE, coordinamento e prevenzione incendi, erogati nel rispetto dei requisiti professionali previsti dalla normativa.",
    intro:
      "Nei cantieri e nei luoghi di lavoro la sicurezza è un obbligo preciso, con documenti e responsabilità definiti dalla legge. Prepariamo la documentazione tecnica necessaria, sempre nei limiti dei requisiti professionali richiesti.",
    quando: [
      "Devi aprire un cantiere e servono i documenti di sicurezza.",
      "Occorre nominare o supportare CSP e CSE.",
      "Serve supporto per gli adempimenti legati alla sicurezza (RSPP), dove previsto.",
      "Devi gestire una pratica di prevenzione incendi.",
    ],
    cosa: [
      "Documenti di sicurezza per cantieri",
      "CSP — Coordinatore per la sicurezza in fase di progetto",
      "CSE — Coordinatore per la sicurezza in fase di esecuzione",
      "Supporto per gli adempimenti RSPP, nei limiti previsti dalla normativa",
      "Pratiche di prevenzione incendi",
    ],
    nota:
      "Prima di accettare l’incarico verifichiamo sempre di possedere i requisiti professionali richiesti dal caso concreto: se il compito appartiene a un’altra figura professionale, te lo diciamo subito.",
    aDistanza:
      "Le attività documentali possono essere gestite anche a distanza. Sopralluoghi, verifiche, coordinamento e presenza in cantiere vengono invece organizzati in funzione dell’incarico e degli obblighi applicabili.",
    formService: "Sicurezza e prevenzione",
  },
  "consulenza-tecnica-documentale": {
    h1: "Consulenza tecnica e documentale",
    description:
      "Supporto tecnico e documentale sugli immobili: contratti di locazione, comodati, preliminari e scritture private compatibili con l’attività professionale.",
    intro:
      "Molte pratiche sugli immobili passano da documenti: contratti, scritture e allegati tecnici. Offriamo una consulenza tecnica e documentale per prepararli correttamente e gestirli con ordine.",
    quando: [
      "Devi redigere o rinnovare un contratto di locazione o un comodato.",
      "Stai firmando un preliminare e vuoi un controllo tecnico dei documenti.",
      "Ti serve una scrittura privata compatibile con l’attività professionale.",
      "Hai bisogno di ordine nella documentazione tecnica di un immobile.",
    ],
    cosa: [
      "Contratti di locazione",
      "Comodati",
      "Preliminari",
      "Altre scritture private compatibili con l’attività professionale",
      "Consulenza tecnica e documentale sull’immobile",
      "Supporto nella raccolta e verifica della documentazione",
    ],
    nota:
      "L’attività del geometra non sostituisce quella di notai e avvocati: per gli atti di loro competenza collaboriamo con i professionisti incaricati.",
    aDistanza:
      "La consulenza documentale si presta perfettamente alla gestione a distanza, con scambi digitali e chiamate di approfondimento.",
    formService: "Consulenza tecnica e documentale",
  },
  "siti-web-personalizzati": {
    h1: "Siti web personalizzati",
    description:
      "Progettazione e realizzazione di siti web personalizzati per attività, professionisti e imprese: chiari, veloci e curati nei dettagli.",
    intro:
      "Progettiamo e realizziamo siti web personalizzati per attività, professionisti e imprese: siti chiari, rapidi e curati, pensati per presentare bene chi li pubblica e per farsi trovare.",
    quando: [
      "Non hai un sito, o ne hai uno vecchio e poco utile.",
      "Vuoi una vetrina chiara per la tua attività o la tua professione.",
      "Ti serve un sito veloce e leggibile anche da smartphone.",
      "Vuoi essere contattato facilmente da chi ti cerca.",
    ],
    cosa: [
      "Progettazione e realizzazione del sito",
      "Siti vetrina e pagine professionali",
      "Ottimizzazione tecnica: velocità e leggibilità",
      "Impostazione SEO di base e indicizzazione",
      "Pubblicazione e assistenza",
    ],
    nota:
      "Questo è un servizio digitale autonomo, separato dall’attività tecnico-catastale dello studio.",
    aDistanza:
      "Il servizio si svolge interamente a distanza: prima call di scoperta, poi progettazione, revisioni e pubblicazione.",
    formService: "Sito web personalizzato",
  },
};
